import styled from "styled-components";

export const ImageContainer = styled.div`
  position: relative;

  img {
    &.bn-hover {
      opacity: 0;

      &.hidden {
        display: none;
      }
    }
  }
`;
